import { BaseApiService } from '@shared/services/BaseApiService';
import { API_URL } from '@shared/helpers/env';
import axios from 'axios';

class SmsVerificationServiceClass extends BaseApiService {
  constructor(opts) {
    super(opts);
  }

  send(token, params = {}) {
    return axios.post(`${API_URL}/api/v2/client/sms-verifications/send`, params, {
      headers: {
        'X-CSRF-TOKEN': token
      }
    });
  }
  check(params) {
    return this.http.post('/check', params);
  }

  token() {
    return axios.get(`${API_URL}/api/v3/frontend/csrf`);
  }
}

export const SmsVerificationService = new SmsVerificationServiceClass({
  api_version: 2,
  resource: 'client/sms-verifications'
});
